<template lang="pug">
  div
    .bg-wrap(v-show='show' @click='confirmClick')
    transition(
      enter-active-class="animated slideInUp"
      leave-active-class="animated slideOutDown"
    )
      .picker-wrap(v-show='show')
        .btn-group
          .btn(@click='extraClick') {{extraText}}
          .btn(@click='confirmClick') 确定
        mt-picker(
          :slots="slots"
          :valueKey='valueKey'
          @change="change"
          ref='picker'
        )
</template>

<script>
export default {
  props: ['show', 'slots', 'valueKey', 'extraText'],
  mounted() {
    this.$emit('init', this.$refs.picker)
  },
  methods: {
    change(picker, values) {
      this.$emit('change', picker, values)
    },
    confirmClick() {
      this.$emit('confirmClick')
    },
    extraClick() {
      this.$emit('extraClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.bg-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 30;
}
.picker-wrap {
  z-index: 40;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid @bd_color;
  background-color: #fff;
  .btn-group {
    display: flex;
    justify-content: space-between;
    padding: 0 2em;
    font-size: 1.2em;
    .btn {
      color: @main_color;
      margin-top: 1em;
    }
  }
}
</style>
